import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function StickersPorCartaDePorte() {
  return (
    <ClipperPlaceholder title="Stickers por Carta de Porte" category="Operativas" />
  );
}
